import { E as EmblaCarousel } from './embla-carousel.esm-CCUHK2kO.js';
import { a as addScrollBarListener } from './scrollbar-CN2h-3bU.js';
import { a as addPrevNextButtonClickHandlers } from './arrow-buttons-CY1f9syu.js';

class TilesSlider extends HTMLElement {
  /** @type {import('embla-carousel').EmblaCarouselType} */
  #embla;

  connectedCallback() {
    this.#embla = EmblaCarousel(this.querySelector('.embla__viewport'), {
      direction: document.dir || 'ltr',
      align: 'center',
      dragFree: true,
      skipSnaps: true,
      slidesToShow: 1.2,
      active: true,
      breakpoints: {
        '(min-width: 768px)': {
          slidesToShow: 3,
        },
        '(min-width: 1280px)': {
          slidesToShow: 4,
        },
      },
    });

    const prevBtn = this.querySelector('.embla-button--prev');
    const nextBtn = this.querySelector('.embla-button--next');

    addScrollBarListener(this.#embla, this.querySelector('.embla__scrollbar'));
    addPrevNextButtonClickHandlers(this.#embla, prevBtn, nextBtn);
  }
}

customElements.define('tiles-slider', TilesSlider);
